module.exports = __webpack_public_path__ + "img/pageDirector_function_white.7dfa7fd2.svg";